import React from "react";
import { Dialog, DialogContent, DialogTitle } from "~/components/dialog";
import { useSnackBar } from "~/components/snackbar";
import { useCreateProjectGroupMutation } from "./mutation.generated";
import TextFormField from "~/components/text-form-field";
import FormBottomRow from "~/components/form-bottom-row";
import Button from "~/components/button";
import { useReload } from "../CustomerContext";
import { FieldOffice, ValidationResponse } from "~/gql/types";
import { ErrorRenderer, MutationForm } from "~/components/forms/MutationForm";
import FieldOfficePickerFormField from "~/visuals/organisms/FieldOfficePickerFormField";

type AddProjectGroupProps = {
  open: boolean;
  setOpen: React.Dispatch<boolean>;
  customerNumber: string;
};

type AddProjectGroupFormValues = {
  name: string | null;
  billingOffice: FieldOffice | null;
};

type AddProjectGroupFormProps = Omit<AddProjectGroupProps, "open">;
export const AddProjectGroup: React.FC<AddProjectGroupProps> = (props) => {
  const { open, setOpen } = props;
  return (
    <>
      <Button
        icon="add"
        className="customer-add-item-button"
        onClick={() => setOpen(true)}
      >
        Add
      </Button>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        className="add-project-group"
      >
        <DialogTitle>Add Project Group</DialogTitle>
        <DialogContent>
          {open && <AddProjectGroupForm {...props} />}
        </DialogContent>
      </Dialog>
    </>
  );
};

export const AddProjectGroupForm: React.FC<AddProjectGroupFormProps> = ({
  setOpen,
  customerNumber,
}) => {
  const [doMutation] = useCreateProjectGroupMutation();

  const addAlert = useSnackBar();
  const reload = useReload();

  const onSuccess = () => {
    const message = "New Project Group added";
    addAlert({
      isSuccess: true,
      message,
      key: `${Math.random()}`,
    });
    setOpen(false);
    reload();
  };
  const handleSubmit = async (values: AddProjectGroupFormValues) => {
    const variables = {
      customerNumber: customerNumber,
      name: values.name!,
      billingOfficeCode: values.billingOffice?.officeCode ?? null,
    };
    const result = await doMutation({ variables });
    return result?.data?.projectGroups?.create as ValidationResponse;
  };

  const initialValues: AddProjectGroupFormValues = {
    name: null,
    billingOffice: null,
  };
  return (
    <MutationForm
      initialValues={initialValues}
      onSuccess={onSuccess}
      runMutation={handleSubmit}
    >
      <TextFormField
        formField={"name"}
        label={"Name"}
        helperText={""}
        required
      />
      <FieldOfficePickerFormField
        formField={"billingOffice"}
        label={"Billing Office"}
        helperText={"Optional. Determines payee info and logo on CRI PDFs."}
      />
      <ErrorRenderer
        render={(formError) => (
          <FormBottomRow
            errorMessage={formError}
            buttonText="Save"
            onCancel={() => setOpen(false)}
          />
        )}
      />
    </MutationForm>
  );
};
